import {observable} from 'mobx';
import {RouterService} from '../RouterService';
import * as history from 'history';
import {Action, Location, Listener} from 'history';

export class ClientRouterService implements Partial<RouterService> {
    @observable
    public accessor pagePath: string = '/de';
    public listeners: Listener[] = [];

    public isAppLink = (url: string): boolean => {
        return !url.startsWith('http');
    };

    public pageResourcePath: string = '/content/onehub_pkw/de/de';

    public getHistory(): history.History {
        return {
            location: {
                pathname: '/'
            },
            listen: (listener: Listener) => {
                this.listeners.push(listener);
            }
        } as history.History;
    }

    public runCallback(location: Location, action: Action) {
        this.listeners.forEach(listener => listener({location, action}));
    }
}
